import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const TableSelectionContainer = styled.div`
    padding: 24px 24px 6px 24px;
`;

export const ModalTableSelectionContainer = styled.div`
    padding: 20px 16px 16px 24px;
`;

export const Title = styled.div`
    height: 20px;
    padding-bottom: 8px;
`;

export const SubTitle = styled.div`
    height: 20px;
    padding-bottom: 16px;
`;

export const AlertMessage = styled(FlexRow)`
    background-color: ${colorsPalettes.bluegrey[200]};
    margin-bottom: 16px;
    padding: 8px 12px 8px 16px;
    border-radius: 3px;
`;
export const AlertText = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    width: calc(100% - 24px);
    margin-left: 8px;
`;
